import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Field, reduxForm } from 'redux-form';

import 'rc-checkbox/assets/index.css';
import '../style.css';

const validate = (formProps) => {
  const errors = {};

  if (!formProps.name) {
    errors.name = 'Required';
  } else if (formProps.name.length < 4) {
    errors.name = 'Must be 4 characters or more';
  } else if (!/(\w.+\s).+/i.test(formProps.name)) {
    errors.name = 'Please enter first and last name';
  }

  if (!formProps.password) {
    errors.password = 'Password is required';
  } else if (formProps.password.length < 4) {
    errors.password = 'Must be 4 characters or more';
  }

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { touched, error, warning },
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  if (touched && error) {
    hasStatus = 'danger';
    message = error;
  } else if (touched && warning) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  }

  return (
    <div
      className={classNames('form-group', {
        'has-danger': hasStatus === 'danger',
        'has-warning': hasStatus === 'warning',
        'has-success': hasStatus === 'success',
      })}
    >
      <input
        id={input.name}
        className="form-control form-control-danger form-control-warning form-control-success"
        {...input}
        disabled={disabled}
        type={type}
        placeholder={label}
      />
      {message ? (
        <div className="form-control-feedback">
          <small>{message}</small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

class SignupDetails extends Component {
  componentWillMount() {
    this.props.initialize({ name: '', password: '' });
  }

  render() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;

    return (
      <form className="AuthForm SignInForm form" onSubmit={handleSubmit}>
        <Field
          name="name"
          component={renderField}
          type="text"
          label="Name"
          placeholder="Full Name"
        />

        <Field
          name="password"
          component={renderField}
          type="password"
          label="Password"
          placeholder="Password"
        />

        <button
          type="submit"
          className="btn submit-btn btn-green btn-lg btn-cursor w-100"
          disabled={pristine || submitting}
          data-qa-id="create-account-button"
        >
          Create Account
        </button>

        {
          // if an error exists, render an Alert
          error && <p className="text-danger my-2">{error}</p>
        }
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(
  reduxForm({ form: 'signupDetails', validate })(SignupDetails)
);



// WEBPACK FOOTER //
// ./src/components/forms/Auth/SignupDetailsForm/index.js